import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BottomTabBar.css';

// Import active icons
import iconPlaygroundActive from '../../assets/icons/icon_bottomtab_playground_active.svg';
import iconSearchActive from '../../assets/icons/icon_bottomtab_search_active.svg';
import iconActivityActive from '../../assets/icons/icon_bottomtab_activity_active.svg';
import iconProfileActive from '../../assets/icons/icon_bottomtab_profile_active.svg';
import iconMessagesActive from '../../assets/icons/icon_bottomtab_messages_active.svg';

// Import inactive icons
import iconPlaygroundInactive from '../../assets/icons/icon_bottomtab_playground_inactive.svg';
import iconSearchInactive from '../../assets/icons/icon_bottomtab_search_inactive.svg';
import iconActivityInactive from '../../assets/icons/icon_bottomtab_activity_inactive.svg';
import iconProfileInactive from '../../assets/icons/icon_bottomtab_profile_inactive.svg';
import iconMessagesInactive from '../../assets/icons/icon_bottomtab_messages_inactive.svg';

const BottomTabBar: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="bottom-tab-bar">
      <Link to="/playground">
        <img 
          src={isActive('/playground') ? iconPlaygroundActive : iconPlaygroundInactive} 
          alt="Playground" 
          width="32" 
          height="32" 
        />
      </Link>
      <Link to="/search">
        <img 
          src={isActive('/search') ? iconSearchActive : iconSearchInactive} 
          alt="Search" 
          width="32" 
          height="32" 
        />
      </Link>
      {/* <Link to="/messages">
        <img 
          src={isActive('/messages') ? iconMessagesActive : iconMessagesInactive} 
          alt="Messages" 
          width="32" 
          height="32" 
        />
      </Link> */}
      <Link to="/activity">
        <img 
          src={isActive('/activity') ? iconActivityActive : iconActivityInactive} 
          alt="Activity" 
          width="32" 
          height="32" 
        />
      </Link>
      <Link to="/profile">
        <img 
          src={isActive('/profile') ? iconProfileActive : iconProfileInactive} 
          alt="Profile" 
          width="32" 
          height="32" 
        />
      </Link>
    </div>
  );
};

export default BottomTabBar;
